import { createApi } from '@reduxjs/toolkit/query/react';

import { baseQueryWithReauth } from '@src/store/base-query';

export const adminApi = createApi({
  reducerPath: 'adminQueries',
  baseQuery: baseQueryWithReauth,
  endpoints: (builder) => ({
    getAdminAnalytics: builder.query({
      query: () => 'users/admin/analytics',
    }),
    getEngagementStats: builder.query({
      query: () => 'users/admin/engagement-stats',
    }),
    sendTestEmail: builder.mutation({
      query: (type) => ({
        url: `users/admin/test-email/${type}`,
        method: 'POST',
      }),
    }),
  }),
});

export const { useGetAdminAnalyticsQuery, useGetEngagementStatsQuery, useSendTestEmailMutation } = adminApi;
